import React from 'react';
import PropTypes from 'prop-types';

const ConsultaCidTussResultView = ({ results, onItemClick }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {results.map((item) => (
        <div
          key={item.id}
          className="border border-gray-300 rounded-lg shadow-sm hover:shadow-md transition-shadow p-4 cursor-pointer"
          onClick={() => onItemClick(item)}
        >
          <h3 className="text-lg font-semibold text-gray-800">{item.id}</h3>
          <p className="text-sm text-gray-600">
            <strong>Código:</strong> {item.id}
          </p>
          <p className="text-sm text-gray-600">
            <strong>Descrição:</strong> {item.name}
          </p>
        </div>
      ))}
    </div>
  );
};

ConsultaCidTussResultView.propTypes = {
  results: PropTypes.array.isRequired,
  onItemClick: PropTypes.func.isRequired,
};

export default ConsultaCidTussResultView;
